var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    width: "45px",
    height: "45px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;fill:#FFEB3B;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:#1D1D1B;stroke:#1D1D1B;stroke-width:0.75;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;stroke:#1D1D1B;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st5{fill:#FFFFFF;}\r\n\t.st6{fill:none;stroke:#1D1D1B;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st7{fill:#1D1D1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.6,
    y: 6.4,
    className: "st1",
    width: 25.3,
    height: 17.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Livello_46",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M7.9,10.4c0-1.1-0.9-2-1.9-2s-2,0.9-2,2s0.9,1.9,1.9,1.9S7.9,11.4,7.9,10.4 M3.5,22.5 C3.5,22.5,3.4,22.5,3.5,22.5l23.1,0.1l0,0l-7.9-10.8c0,0-0.9-1.3-1.9,0l-4.9,6.7L10.1,16c0,0-0.9-1.3-1.9,0L3.5,22.5z M27.4,23.3 H2.6V6.7h24.7L27.4,23.3L27.4,23.3z M28.4,23.8V6.2c0-0.3-0.2-0.5-0.5-0.5H2.1c-0.3,0-0.5,0.2-0.5,0.5v17.6c0,0.3,0.2,0.5,0.5,0.5 h25.8C28.2,24.3,28.4,24.1,28.4,23.8"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.3,
    y: 4.7,
    transform: "matrix(0.9659 -0.2588 0.2588 0.9659 -3.3781 4.4101)",
    className: "st4",
    width: 23.5,
    height: 20.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6.6,
    transform: "matrix(0.9659 -0.2588 0.2588 0.9659 -3.0114 4.2278)",
    className: "st5",
    width: 19.1,
    height: 13.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "3.9,12.2 3.1,9.4 22.3,4.3 24.8,13.6  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "4.3,13.7 6.7,22.8 25.9,17.7 25.4,15.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "5.8,19.2 6.7,22.5 25.6,17.5 10.3,14.1 8.4,14.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "9.7,14.6 9.4,14.2 9.1,14.3 9.4,14.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "10.3,15.3 9.9,14.9 9.5,15 9.8,15.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "10.5,15.6 10.9,16.2 10.3,16.3 10,15.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "11.3,16.7 12.2,17.9 11.4,18.1 10.6,16.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "12.8,18.7 14.1,20.5 13,20.8 11.9,18.9  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoto);
export default __webpack_public_path__ + "static/media/photo.e7c93353a0622f179918da3f389e6699.svg";
export { ForwardRef as ReactComponent };